import { Flex, Card, Skeleton } from '@blockanalitica/ui';

export default function ListSkeleton() {
  return (
    <Flex flexDirection="column" gap="xs">
      <Flex justifyContent="space-between" alignItems="center">
        <Skeleton height="5" width="10" />
      </Flex>

      <Card gap="2xs" display="flex" flexDirection="column">
        <Skeleton height="10" />
      </Card>
    </Flex>
  );
}
